import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as jobsApi from "@/services/jobsApi";

export const jobsKeys = {
  all: ["jobs"] as const,
  list: () => [...jobsKeys.all, "list"] as const,
};

export function useJobList(refetchInterval?: number) {
  return useQuery({
    queryKey: jobsKeys.list(),
    queryFn: jobsApi.listJobs,
    refetchInterval: refetchInterval ?? 0,
  });
}

export function useDeleteJobs() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (scope: jobsApi.JobDeleteScope) => jobsApi.deleteJobs(scope),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: jobsKeys.all });
    },
  });
}
